<template>
  <div class="el-col-24">
    <h5 class="warp-title">统计总览</h5>
    <div class="customer-status-info">
      <div>当前客服情况：</div>
      <div class="status-item">
        <i class="bg-green"></i>
        <span>在线：{{customerData.onlineCount}} 人</span>
      </div>
      <div class="status-item">
        <i class="bg-orange"></i>
        <span>挂起：{{customerData.hangCount}} 人</span>
      </div>
      <el-button size="mini" @click="showAllCustomer = !showAllCustomer" type="primary" plain class="mr15">{{ showAllCustomer ? '收起离线客服' : '查看所有' }}</el-button>
      <el-button size="mini" @click="doRefresh" type="success" plain :loading="isCustomerListLoading" v-if="showAllCustomer">实时刷新</el-button>
    </div>
    <div v-if="showAllCustomer" v-loading="isCustomerListLoading">
      <ul class="customer-con" :class="{'customer-con-hight': customerHight === 2}" v-if="customerList.length > 0">
        <li v-for="(item, index) in customerList" :key="index" :class="{'customer-con-zaixian': item.lineStatus === 2, 'customer-con-lixian': item.lineStatus === 1, 'customer-con-guaqi': item.lineStatus === 3}" @click="toWorkDetail(item)">
          <div class="customer-con-img" v-if="item.realName">
            <p class="real-name-box">{{item.realName}}</p>
          </div>
          <div class="customer-con-img" v-else>
            <img src="../../common/img/tykf_avatar.png" alt="" srcset="">
          </div>
          <div class="customer-con-dl">
            <div>{{item.nickName}}</div>
            <div class="gray">{{item.realName}}</div>
          </div>
        </li>
      </ul>
      <div class="no-customer-tips" v-else>
        <img src="../../common/img/no-course.png" alt="">
        <span>暂无在线/挂起的客服</span>
      </div>
    </div>
    <h5 class="warp-title">接待总量</h5>
    <div class="search">
      <div class="clearfix">
        <div class="search-type">
          <span class="search-title">时间类型</span>
          <el-radio-group v-model="timeType1" size="small">
            <el-radio-button :label="1">按天</el-radio-button>
            <el-radio-button :label="2">按月</el-radio-button>
          </el-radio-group>
        </div>
        <div class="search-type">
          <el-radio-group v-model="date1" size="small" @change="changeDate1">
            <el-radio-button :label="1">30天</el-radio-button>
            <el-radio-button :label="2">近7天</el-radio-button>
            <el-radio-button :label="3">今天</el-radio-button>
          </el-radio-group>
        </div>
        <div class="search-type">
          <span class="search-title">统计时间</span>
          <el-date-picker
            @change="changeTime1"
            v-model="time1"
            size="small"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
        <div class="search-type">
          <el-button size="small" type="primary" @click="search1()" :loading="isSearch1">查询</el-button>
        </div>
        <div class="search-type">
          <el-button size="small" @click="export1()" :loading="isExport1">导出</el-button>
        </div>
      </div>
    </div>
    <div id="numAll" style="height:400px;">
    </div>
    <!-- <div class="problem-warp"> -->
    <h5 class="warp-title">问题分类</h5>
    <div class="search">
      <div class="clearfix">
        <div class="search-type">
          <el-radio-group v-model="date2" size="small" @change="changeDate2">
            <el-radio-button :label="1">30天</el-radio-button>
            <el-radio-button :label="2">近7天</el-radio-button>
            <el-radio-button :label="3">今天</el-radio-button>
          </el-radio-group>
        </div>
        <div class="search-type">
          <span class="search-title">统计时间</span>
          <el-date-picker
            @change="changeTime2"
            v-model="time2"
            size="small"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
        <div class="search-type">
          <el-button size="small" type="primary" @click="search2()" :loading="isSearch2">查询</el-button>
        </div>
        <div class="search-type">
          <el-button size="small" @click="export2()" :loading="isExport2">导出</el-button>
        </div>
      </div>
    </div>
    <div id="problem1" style="width: 100%;height:400px;"></div>
    <div class="flex-common-style" style="margin: 20px 0 30px">
      <h5 class="warp-title" style="margin: 0 10px 0 0">二级问题分类</h5>
      <el-select style="width: 200px" v-model="problemOneType" size="mini" placeholder="请选择">
        <el-option v-for="(item, index) in oneTypeOption" :key="index" :label="item.name" :value="item.code"></el-option>
      </el-select>
    </div>
    <div class="search">
      <div class="clearfix">
        <div class="search-type">
          <el-radio-group v-model="date3" size="small" @change="changeDate3">
            <el-radio-button :label="1">30天</el-radio-button>
            <el-radio-button :label="2">近7天</el-radio-button>
            <el-radio-button :label="3">今天</el-radio-button>
          </el-radio-group>
        </div>
        <div class="search-type">
          <span class="search-title">统计时间</span>
          <el-date-picker
            @change="changeTime3"
            v-model="time3"
            size="small"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
        <div class="search-type">
          <el-button size="small" type="primary" @click="search3()" :loading="isSearch3">查询</el-button>
        </div>
        <div class="search-type">
          <el-button size="small" @click="export3()" :loading="isExport3">导出</el-button>
        </div>
      </div>
    </div>
    <div id="problem2" style="height:600px;"></div>
    <!-- </div> -->
  </div>
</template>

<script>
import {queryBusinessTypeList} from '../../api/order/index'
import {queryCurrentCustomerStatus, queryCurrentCustomerStatusList, queryCustomerReceptionOverview, queryLevelOneProblem, queryLevelTwoProblem, exportCustomerReceptionOverview, exportLevelOneProblem, exportLevelTwoProblem} from '../../api/statistics/index'
import { queryButtonPermission } from '../../api/public/auth'
export default {
  name: 'Statistics',
  created () {
    // 打印是否登录
    console.log(this.$store.state.Auth.sign)
    let data = {
      id: global.$sider
    }
    queryButtonPermission(data).then((info) => {
      if (info.data.resultCode === 0) {
        this.querybtn = info.data.resultData
      } else {
        this.$message.error(info.data.resultMessage)
      }
    })
  },
  data () {
    return {
      isCustomerListLoading: false,
      showAllCustomer: true,
      isExport3: false,
      isExport2: false,
      isExport1: false,
      isSearch3: false,
      isSearch2: false,
      isSearch1: false,
      querybtn: {},
      customerData: {},
      customerHight: 1,
      customerList: [],
      timeType1: 1,
      timeType2: 1,
      timeType3: 1,
      date1: 1,
      date2: 1,
      date3: 1,
      problemOneType: '',
      oneTypeOption: [],
      time1: [],
      time2: [],
      time3: []
    }
  },
  methods: {
    // 刷新客服数据
    doRefresh () {
      this.getCustomerStatistics()
      this.getOnlineCustomerList()
    },
    // 获取客服列表（在线+挂起）
    getOnlineCustomerList () {
      this.isCustomerListLoading = true
      queryCurrentCustomerStatusList().then(info => {
        if (info.data.resultCode === 0) {
          // 过滤掉离线的客服
          this.customerList = info.data.resultData.filter(item => item.lineStatus !== 1)
        } else {
          this.$message.error(info.data.resultMessage)
        }
      }).finally(() => {
        this.isCustomerListLoading = false
      })
    },
    toWorkDetail (item) {
      this.$router.push({
        name: 'WorkDetail',
        params: {
          id: item.id
        },
        query: {
          num: item.nickName,
          name: item.realName
        }
      })
    },
    changeCustomer () {
      if (this.customerHight === 1) {
        this.customerHight = 2
      } else {
        this.customerHight = 1
      }
    },
    changeTime1 () {
      this.date1 = ''
    },
    changeDate1 () {
      this.time1 = []
    },
    changeTime2 () {
      this.date2 = ''
    },
    changeDate2 () {
      this.time2 = []
    },
    changeTime3 () {
      this.date3 = ''
    },
    changeDate3 () {
      this.time3 = []
    },
    initdata1 () {
      let startTime = ''
      let endTime = ''
      if (this.time1 && this.time1.length > 0) {
        startTime = this.time1[0]
        endTime = this.time1[1]
      }
      let data = {
        timeType: this.timeType1,
        specifiedTime: this.date1,
        startTime: startTime,
        endTime: endTime
      }
      this.isSearch1 = true
      queryCustomerReceptionOverview(data).then(info => {
        this.isSearch1 = false
        if (info.data.resultCode === 0) {
          let chartData = info.data.resultData
          let xData = []
          let nameData = []
          let seriesData = []
          if (info.data.resultData[0]) {
            xData = info.data.resultData[0].dateDate
          }
          chartData.forEach(ele => {
            nameData.push(ele.name)
            seriesData.push({
              name: ele.name,
              type: 'bar',
              data: ele.dateResult
            })
          })
          let myChart = this.$echarts.init(document.getElementById('numAll'))
          myChart.hideLoading()
          myChart.setOption({
            color: ['#02B2FF', '#15C9BD', '#FFAC0F', '#8A8EFF'],
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            grid: {
              left: '1%',
              containLabel: true
            },
            legend: {
              data: nameData
            },
            xAxis: [
              {
                type: 'category',
                axisTick: {show: false},
                data: xData
              }
            ],
            yAxis: [
              {
                type: 'value'
              }
            ],
            series: seriesData
          })
        } else {
          this.$message.error(info.data.resultMessage)
        }
      }).catch(() => {
        this.isSearch1 = false
      })
    },
    // 渲染图表数据
    mountData3 (chartData) {
      let xData = chartData.map(item => item.typeName)
      let yData = chartData.map(item => item.workOrderCount)
      let myChart1 = this.$echarts.init(document.getElementById('problem1'))
      myChart1.hideLoading()
      myChart1.setOption({
        xAxis: {
          type: 'category',
          data: xData,
          axisLabel: {
            show: true,
            interval: 0
          }
        },
        yAxis: {
          type: 'value'
        },
        grid: {
          left: '1%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        series: {
          type: 'bar',
          barCategoryGap: '30%',
          barWidth: '30%',
          data: yData,
          label: {
            show: true, // 是否显示
            position: 'top'
          },
          itemStyle: {
            // 每个柱单独颜色
            normal: {
              color: function (params) {
                var colorlist = [ '#009933', '#99CC00', '#FF6600', '#FFCC33', '#FFCC99', '#336699', '#33CC99', '#009933', '#99CC00', '#FF6600', '#FFCC33', '#FFCC99', '#336699', '#33CC99', '#009933', '#99CC00', '#FF6600', '#FFCC33', '#FFCC99', '#336699', '#33CC99' ]
                return colorlist[params.dataIndex]
              }
            }
          }
        },
        toolbox: {
          feature: {
            saveAsImage: {},
            magicType: {
              type: ['bar', 'line']
            }
          }
        }
      })
    },
    initdata2 () {
      let startTime = ''
      let endTime = ''
      if (this.time2 && this.time2.length > 0) {
        startTime = this.time2[0]
        endTime = this.time2[1]
      }
      let data = {
        startTime: startTime,
        endTime: endTime,
        specifiedTime: this.date2
      }
      this.isSearch2 = true
      queryLevelOneProblem(data).then(info => {
        this.isSearch2 = false
        if (info.data.resultCode === 0) {
          let chartData = info.data.resultData
          // 从高到低排序
          chartData.sort((a, b) => b.workOrderCount - a.workOrderCount)
          this.mountData3(chartData)
        } else {
          this.$message.error(info.data.resultMessage)
        }
      }).catch(() => {
        this.isSearch2 = false
      })
    },
    initdata3 () {
      let startTime = ''
      let endTime = ''
      if (this.time3 && this.time3.length > 0) {
        startTime = this.time3[0]
        endTime = this.time3[1]
      }
      let data = {
        code: this.problemOneType,
        startTime: startTime,
        endTime: endTime,
        specifiedTime: this.date3
      }
      this.isSearch3 = true
      queryLevelTwoProblem(data).then(info => {
        this.isSearch3 = false
        if (info.data.resultCode === 0) {
          let chartData = info.data.resultData
          let myChart2 = this.$echarts.init(document.getElementById('problem2'))
          myChart2.hideLoading()
          myChart2.setOption({
            color: ['#02B2FF'],
            tooltip: {
              trigger: 'axis',
              axisPointer: { // 坐标轴指示器，坐标轴触发有效
                type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
              }
            },
            grid: {
              left: '1%',
              containLabel: true
            },
            xAxis: [
              {
                type: 'category',
                axisLabel: { // 坐标轴刻度标签的相关设置。
                  rotate: 60 // 文字倾斜度
                },
                data: chartData.xtwoList,
                axisTick: {
                  alignWithLabel: true
                }
              }
            ],
            yAxis: [
              {
                type: 'value'
              }
            ],
            series: [
              {
                name: '工单数量',
                type: 'bar',
                barWidth: '30%',
                data: chartData.ytwoCountList
              }
            ]
          })
        } else {
          this.$message.error(info.data.resultMessage)
        }
      }).catch(() => {
        this.isSearch3 = false
      })
    },
    search1 () {
      this.initdata1()
    },
    search2 () {
      this.initdata2()
    },
    search3 () {
      this.initdata3()
    },
    export1 () {
      let startTime = ''
      let endTime = ''
      if (this.time) {
        startTime = this.time[0]
        endTime = this.time[1]
      }
      let data = {
        timeType: this.timeType1,
        specifiedTime: this.date1,
        startTime: startTime,
        endTime: endTime
      }
      this.isExport1 = true
      exportCustomerReceptionOverview(data).then(info => {
        this.isExport1 = false
        if (info.data.resultCode === 0) {
          let Url = info.data.resultData.fileDownLoadUrl
          window.open(Url)
        } else {
          this.$message.error(info.data.resultMessage)
        }
      }).catch(() => {
        this.isExport1 = false
      })
    },
    export2 () {
      let startTime = ''
      let endTime = ''
      if (this.time) {
        startTime = this.time[0]
        endTime = this.time[1]
      }
      let data = {
        startTime: startTime,
        endTime: endTime,
        specifiedTime: this.date2
      }
      this.isExport2 = true
      exportLevelOneProblem(data).then(info => {
        this.isExport2 = false
        if (info.data.resultCode === 0) {
          let Url = info.data.resultData.fileDownLoadUrl
          window.open(Url)
        } else {
          this.$message.error(info.data.resultMessage)
        }
      }).catch(() => {
        this.isExport2 = false
      })
    },
    export3 () {
      let startTime = ''
      let endTime = ''
      if (this.time) {
        startTime = this.time[0]
        endTime = this.time[1]
      }
      let data = {
        code: this.problemOneType,
        startTime: startTime,
        endTime: endTime,
        specifiedTime: this.date3
      }
      this.isExport3 = true
      exportLevelTwoProblem(data).then(info => {
        this.isExport3 = false
        if (info.data.resultCode === 0) {
          let Url = info.data.resultData.fileDownLoadUrl
          window.open(Url)
        } else {
          this.$message.error(info.data.resultMessage)
        }
      }).catch(() => {
        this.isExport3 = false
      })
    },
    getCustomerStatistics () {
      queryCurrentCustomerStatus().then(info => {
        if (info.data.resultCode === 0) {
          this.customerData = info.data.resultData
        } else {
          this.$message.error(info.data.resultMessage)
        }
      })
    }
  },
  mounted () {
    let data = {
      typeCode: 'im_customer_problem_one_type'
    }
    queryBusinessTypeList(data).then(info => {
      if (info.data.resultCode === 0) {
        this.oneTypeOption = info.data.resultData
        if (info.data.resultData[0]) {
          this.problemOneType = info.data.resultData[0].code
        }
      } else {
        this.$message.error(info.data.resultMessage)
      }
    })
    this.getCustomerStatistics()
    this.getOnlineCustomerList()
    let myChart = this.$echarts.init(document.getElementById('numAll'))
    myChart.showLoading({
      text: '暂无数据',
      color: '#ffffff',
      textColor: '#8a8e91',
      maskColor: 'rgba(255, 255, 255, 0.8)'
    })
    let myChart1 = this.$echarts.init(document.getElementById('problem1'))
    myChart1.showLoading({
      text: '暂无数据',
      color: '#ffffff',
      textColor: '#8a8e91',
      maskColor: 'rgba(255, 255, 255, 0.8)'
    })
    let myChart2 = this.$echarts.init(document.getElementById('problem2'))
    myChart2.showLoading({
      text: '暂无数据',
      color: '#ffffff',
      textColor: '#8a8e91',
      maskColor: 'rgba(255, 255, 255, 0.8)'
    })
  }
}
</script>
<style lang="less" scoped>
.search{
  a{
    line-height: 32px;
  }
}
.el-tabs{
  margin-top: 20px;
}
.el-button + .el-button{
  margin-left: 0;
}
.customer-status-info{
  display: flex;
  align-items: center;
  color: #303133;
  font-size: 16px;
  .status-item{
    display: flex;
    align-items: center;
    margin-right: 20px;
    i{
      width: 12px;
      height: 12px;
      border-radius: 50%;
      margin-right: 6px;
    }
  }
}
.customer-con{
  // width: 900px;
  // max-height: 216px;
  display: flex;
  flex-wrap: wrap;
  li{
    display: flex;
    align-items: center;
    flex-shrink: 0;
    width: 160px;
    height: 46px;
    background: #EBEEF5;
    border-radius: 8px;
    margin: 20px 20px 0 0;
    padding: 21px 10px;
    position: relative;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, .2);
    cursor: pointer;
    .customer-con-img{
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 50px;
      height: 50px;
      margin-right: 10px;
      border-radius: 50%;
      overflow: hidden;
      background: #409EFF;
      // line-height: 50px;
      // text-align: center;
      color: #ffffff;
      font-size: 12px;
      .real-name-box{
        max-width: 96%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      img{
        width: 100%;
        height: 100%;
      }
    }
    .customer-con-dl{
      line-height: 23px;
      font-size: 14px;
      color: #181C2F;
      .gray{
        max-width: 80px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  li:after{
    content: '';
    width: 44px;
    height: 20px;
    background: #54D339;
    border-radius: 0px 9px 0px 9px;
    display: block;
    position: absolute;
    right: 0;
    top: 0;
    text-align: center;
    line-height: 20px;
    color: #ffffff;
    font-size: 12px;
  }
  .customer-con-zaixian::after{
    content: '在线';
    background: #54D339;
  }
  .customer-con-guaqi::after{
    content: '挂起';
    background: #FFB400;
  }
  .customer-con-lixian::after{
    content: '离线';
    background: #999999;
  }
}
.no-customer-tips{
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: 50%;
  // height: 200px;
  // margin: 60px auto;
  color: #999;
  // text-align: center;
  img{
    width: 100px;
  }
}
.customer-con-hight{
  max-height: inherit;
}
.problem-warp{
  .fl{
    width: 650px;
  }
}
.warp-title{
  height: 28px;
  span{
    margin-right: 20px;
  }
  span, .w100{
    float: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Statistics/Index.vue